import ActionTypes from '../constants/ActionTypes';

const handleLocationChange = (
  board,
  boardUsers,
  labels,
  lists,
  cards,
  cardMemberships,
  cardLabels,
  attachments,
  cardRelations,
) => {
  console.log('ACTION CREATED');
  console.log({
    board,
    boardUsers,
  });

  return {
    type: ActionTypes.LOCATION_CHANGE_HANDLE,
    payload: {
      board,
      boardUsers,
      labels,
      lists,
      cards,
      cardMemberships,
      cardLabels,
      attachments,
      cardRelations,
    },
  };
};

handleLocationChange.fetchBoard = (id) => ({
  type: ActionTypes.LOCATION_CHANGE_HANDLE__BOARD_FETCH,
  payload: {
    id,
  },
});

export default {
  handleLocationChange,
};
